import { useState, useEffect } from "react";
import { fetchData } from "../../api";  
import AngleR from "../../images/icons/angleR.svg";

export default function AboutBanner() {
    const [aboutBannerData, setAboutBannerData] = useState(null); 

    useEffect(() => {
        fetchData("about-banners", true).then(data => setAboutBannerData(data?.[0])); 
    }, []);

    return (
        <main className="pb-20 max-sm:pb-0">
            <div className="relative w-full before:bg-[#000]/50 before:backdrop-blur-[0px] before:absolute before:left-0 before:top-0 before:w-full before:h-full max-sm:h-[360px] ">
                {aboutBannerData && (
                    <img
                        src={`${process.env.NEXT_PUBLIC_STRAPI_URL || "https://api.bouwbedrijfgeluk.nl"}${aboutBannerData.BackgroundImage?.url}`}
                        alt="About Banner Background"
                        className="w-full h-full object-cover lg:max-h-[800px]"
                    />
                )}
                <div className="absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 z-20">
                    {aboutBannerData && (
                        <>
                            <h1 className="text-white mb-6">Contact Us</h1>
                            <ul className="flex items-center justify-center gap-5">
                                <li className="flex items-center gap-3">
                                    <a href={aboutBannerData?.HomeBtnUrl} className="font-semibold">{aboutBannerData?.HomeBtn}</a>
                                    <img src={AngleR} className="h-3"/>
                                </li>
                                <li><a href={aboutBannerData.PageNameUrl} className="font-semibold">Contact Us</a></li>
                            </ul>
                        </>
                    )}
                </div>
            </div>
        </main>
    );
}
